export default {
  isPending(state) {
    return !!(state.status && state.status.enabled && !state.status.accepted);
  }
};
